export default "/images/bloomberg.svg?51fb8509944ac581ddd5dae1dbd515a5";